export const projectsMetadata = [
  {
    title: "Advent of Code",
    link: "https://github.com/Calvinjmin/Advent",
    image: "https://via.placeholder.com/400x250?text=Advent+of+Code",
    description:
      "A fun coding challenge in December to improve problem-solving skills.",
    tags: ["C++", "Python"],
  },
  {
    title: "Databricks CPP SDK",
    link: "https://github.com/Calvinjmin/databricks-sdk-cpp",
    description:
      "An open-source, CPP SDK that interacts with Databricks' API.",
    tags: ["C++", "Databricks", "SDK"],
  },
  {
    title: "Realtime RAG Agent",
    link: "https://github.com/databricks-solutions/realtime-rag-agents-databricks-youcom",
    description:
      "Production-ready implementation of a RAG-powered AI Agent on Databricks with You.com",
    tags: ["Agentic AI", "Solutions Accelerator", "RAG", "Databricks", "You.com"],
  },
  {
    title: "wyaFile",
    link: "https://github.com/Calvinjmin/wyaFile",
    image: "",
    description: "Modernize Grep! An indexing tool for your local files.",
    tags: ["C++", "Shell", "CMake"]
  },
  {
    title: "Hoop Stats",
    link: "https://github.com/Calvinjmin/HoopStats",
    image: "https://via.placeholder.com/400x250?text=Hoop+Stats",
    description: "A web scraping package for NBA players and teams.",
    tags: ["Python", "Poetry"],
  },
  {
    title: "Interview Prep",
    link: "https://github.com/Calvinjmin/Interview_Questions",
    image: "https://via.placeholder.com/400x250?text=Interview+Prep",
    description:
      "A collection of solutions to common coding interview questions.",
    tags: ["C++", "Python"],
  },
  {
    title: "Personal Portfolio",
    link: "https://github.com/Calvinjmin/Portfolio-Modern/",
    image: "https://via.placeholder.com/400x250?text=Personal+Portfolio",
    description: "My personal website.",
    tags: ["React JS", "Tailwind"],
  },
  {
    title: "Trading Simulator",
    link: "https://github.com/Calvinjmin/Trading-Simulator",
    image: "https://via.placeholder.com/400x250?text=Trading+Simulator",
    description: "A stock trading simulator to practice investment strategies.",
    tags: ["Python", "Yfinance", "Pandas"],
  },
];
